module.exports = __webpack_public_path__ + "static/media/click.54838f5b.mp3";